import { render, staticRenderFns } from "./ImpoveActiveStudent.vue?vue&type=template&id=4414e82c&"
import script from "./ImpoveActiveStudent.vue?vue&type=script&lang=js&"
export * from "./ImpoveActiveStudent.vue?vue&type=script&lang=js&"
import style0 from "./ImpoveActiveStudent.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports